

const Config = {
  Manager_URL: "",
  COORDINATOR_URL: "",
  REPORTS_URL: "",
  BASE_URL: "",
  USER_URL:"",
  mediaUrl:""
};
 
export default Config;
